/**
 * abilityVfxOverload — Ryze Q Overload runic energy bolt (SP-09).
 */
export function buildOverload(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.4 * (spec.scale || 1);
  const ink = mat(THREE, spec.color || 0x818cf8, 0.92);
  const glow = mat(THREE, 0xc7d2fe, 0.88);
  addCoreAndGlyphs(THREE, group, s, ink, glow);
  addTrail(THREE, group, s, ink);
  group.userData = { shape: 'overload' };
  return group;
}

function addCoreAndGlyphs(THREE, group, s, ink, glow) {
  group.add(new THREE.Mesh(new THREE.SphereGeometry(s, 10, 10), glow));
  for (let i = 0; i < 3; i += 1) {
    const glyph = new THREE.Mesh(new THREE.BoxGeometry(0.08 * s, 0.28 * s, 0.04 * s), ink);
    const a = (Math.PI * 2 / 3) * i;
    glyph.position.set(Math.cos(a) * s * 0.85, Math.sin(a) * s * 0.55, 0);
    group.add(glyph);
  }
}

function addTrail(THREE, group, s, ink) {
  for (let i = 0; i < 2; i += 1) {
    const spark = new THREE.Mesh(new THREE.BoxGeometry(0.06 * s, 0.06 * s, 0.45 * s), ink);
    spark.position.set((i === 0 ? -0.2 : 0.2) * s, 0, -0.55 * s);
    group.add(spark);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
